import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { ISnIsSharable } from '../../interfaces/is-sharable';

@Component({
  selector: 'sn-object-share-status',
  templateUrl: './object-share-status.component.html',
  styleUrls: ['./object-share-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnObjectShareStatusComponent {
  @Input()
  public object: ISnIsSharable;

  constructor() {}
}
